const aws_region = "us-east-1";

const config = {
  appName: "Cash Sweep UI - Prod",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_NRfZvRYe9`,
    domain: `pgi-cashsweep-domain-prod.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://pgi-cashsweep-domain-prod.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "pgi-cashsweep-identity-provider",
    redirectUrl: "https://www.gmmcashsweep.fundaccounting.principal.com",
    clientId: "2ng4f45nir4f06kapsumjsd6re",
    scope: "pgi-cashsweep-resource-server/read-write",
    updateGroup: "pgi-cashsweep-read-write-client",
  },
  api: {
    baseUrl: `https://0jtxxug5qd.execute-api.us-east-1.amazonaws.com/prod/api/v1`,
  },
};

export default config;
